<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-tag</v-icon> Tag
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <h4 class="primary--text">Tutti i Tag</h4>
      <br>
      <div class="text-center">
        <v-chip
          :key="tag.name"
          class="chip "
          v-for="tag in tags"
          @click="addTag(tag)"
        >{{tag.name}}</v-chip>
        <span v-if="tags.length === 0 && (selectedTags === null || selectedTags.length !== 0)">Non hai ancora creato nessun tag.</span>
        <span v-else-if="tags.length === 0">Hai selezionato tutti i tag.</span>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <h4 class="primary--text">Tag selezionati</h4>
      <br>
      <div class="text-center">
        <v-chip
          :key="tag.name"
          class="chip"
          color="accent"
          v-for="tag in selectedTags"
          @click="removeTag(tag)"
        >{{tag.name}}</v-chip>
        <span v-if="selectedTags === null || selectedTags.length !== 0">Nessun tag selezionato.</span>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <tag-create></tag-create>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import TagCreate from './TagCreate'

  export default {
    name: 'ArticleTag',
    components: {
      TagCreate
    },
    data() {
      return {
        tags: [],
        selectedTags: []
      }
    },
    methods: {
      ...mapActions([
        'fetchTags'
      ]),
      addTag(tag) {
        this.selectedTags.push(tag)
        this.tags = this.tags.filter(el => {
          return el != tag
        })
      },
      removeTag(tag) {
        this.tags.push(tag)
        this.selectedTags = this.selectedTags.filter(el => {
          return el != tag
        })
      },
      compare(a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    },
    computed: {
      ...mapGetters([
        'allTags',
        'newArticle'
      ])
    },
    watch: {
      allTags(val) {
        let lastInserted = val.reduce((prev, current) => {
          return (prev.id > current.id) ? prev : current
        })

        this.tags.push(lastInserted)
        this.tags.sort(this.compare)
      },
      selectedTags(val) {
        this.$store.commit('SET_ARTICLE_TAGS', val)
      },
      newArticle: {
        handler(val) {
          if (typeof val.tags == Object) {
            this.selectedTags = val.tags
          } else if (typeof val.tags == String) {
            this.selectedTags = val.split(',').map(el => {
              return { name: el }
            })
          } else {
            this.selectedTags = []
          }
        },
        deep: true
      }
    },
  }
</script>

<style scoped>
  .chip {
    margin: 4px;
  }
</style>